// extracted by mini-css-extract-plugin
export var input = "components-forms-inputs-__RadioInput-module___input";
export var label = "components-forms-inputs-__RadioInput-module___label";
export var radioButton = "components-forms-inputs-__RadioInput-module___radioButton";
export var radioInput = "components-forms-inputs-__RadioInput-module___radioInput";